module.exports = __webpack_public_path__ + "prod/1.42.2/img/font3.64b9b459.png";